<template>
    <menu-item :name="$t('JoinGame')" v-if='!enterCode' @select="joinGame" icon='/static/images/icons/join_game.svg' />
    <div class="input-group" style='margin-right: 8px;width:250px' v-if='enterCode'>
        <span class="input-group-text" id="basic-addon1">{{$t('Code')}}</span>
        <input ref='code' v-model='code' maxlength="7" type="text" class="form-control" :placeholder="$t('EnterCode')" />
        <button class="btn btn-success" type="button" id="button-addon2" @click='join'>{{$t('Join')}}</button>
    </div>
</template>

<script>
import i18n from '@root/components/i18n';
import MenuItem from './menu_item.vue';

export default {
    mixins: [i18n],
    props: [],
    components: {
        MenuItem,
    },
    data() {
        return {            
            code: '',
            enterCode: false,
        };
    },
    mounted() {
    },
    methods: {
        joinGame() {
            this.enterCode = true;
            this.$nextTick(()=>{
                this.$refs.code.focus();
            });
        },
        join() {
            const regex = /(\d{3})-?(\d{3})/;
            const parts = regex.exec(this.code);
            if (parts.length > 2) {
                const code = parts[1] + "-" + parts[2];
                document.location = "/join/" + code;
            }
        },        
    }
}
</script>

<style lang="scss" scoped>
    @import '@root/common';

</style>

<i18n>
{
    en: {
        JoinGame: "Join challenge",
        EnterCode: "000-000",
    },
    ru: {
        JoinGame: "Присоединиться к игре",
        Code: "Код",
        EnterCode: "000-000",
        Join: "Вперёд",
    }
}
</i18n>